module.exports = __webpack_public_path__ + "static/img/223_TO8_1947.064d5ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/223_TO8_1947.jpg
// module id = USFI
// module chunks = 0